import styled, { css } from 'styled-components';
import { ReactResponsiveCarousel as ReactResponsiveCarouselComponent } from 'src/components';

const ReactResponsiveCarousel = styled(ReactResponsiveCarouselComponent)(
  ({ theme }) => css`
    width: 592px;
    margin-left: auto;
    margin-right: auto;

    ul.slider {
      max-width: 100%;
    }

    .carousel-slider {
      padding-bottom: ${theme.sz.s3};
    }

    .control-dots {
      max-width: 100%;
      left: ${theme.sz.s0};
      right: ${theme.sz.s0};

      .dot {
        width: ${theme.DEPRECATED_ty.smallest};
        height: ${theme.DEPRECATED_ty.smallest};
        margin: ${theme.sz.s0} ${theme.sz.s05};
        box-shadow: none;
        background: ${theme.co.secondary80};
      }

      .dot.selected {
        background: ${theme.co.secondary20};
      }
    }

    .slide img {
      width: ${theme.DEPRECATED_ty.mediumLarge};
      height: ${theme.DEPRECATED_ty.mediumLarge};
    }
  `,
);

export default ReactResponsiveCarousel;
